export class ApiResponse {

  public message: string | undefined;
  public data: any;
  public errors: any[] | Map<string, string> | undefined;

}
